<div class="grid-container">
	<dx-data-grid [dataSource]="linkInformationSettingTemplateBlacklist$ | async" [allowColumnResizing]="true" [allowColumnReordering]="true" [wordWrapEnabled]="true" (onSaving)="onRowSaving($event)" (onRowRemoved)="onRowDeleting($event)">

		<dxo-filter-row [visible]="true"></dxo-filter-row>
		<dxo-editing [allowAdding]="true" [allowUpdating]="false" [allowDeleting]="true"></dxo-editing>

		<dxi-column dataField="linkInformationId" caption="Link information template" [width]="400">
			<dxo-lookup [dataSource]="linkInformation$ | async" valueExpr="id" displayExpr="displayName">
			</dxo-lookup>
		</dxi-column>

		<dxi-column dataField="settingTemplateId" caption="Link setting template">
			<dxo-lookup [dataSource]="settingTemplate$ | async" valueExpr="id" [displayExpr]="customDisplayExpr">
			</dxo-lookup>
		</dxi-column>
	</dx-data-grid>
</div>
